const seed = Math.random().toString(36).substring(2, 8); // Generated once when first imported
let globalCounter = 0; // Singleton counter

export const generateId = (prefix?: string) => {
    globalCounter += 1;
    return prefix
        ? `${prefix}-${seed}-${globalCounter}`
        : `${seed}-${globalCounter}`;
};
